<template>
  <!-- 平台 -->
  <div class="content-item white">
    <div class="content-items">
      <p class="title">一站式二手数码产品服务平台</p>
      <div class="image-list">
        <div class="image-item" v-for="(item, index) in imageList" :key="index">
          <img
            :src="isMaxScreen ? item.image : item.image1"
            :alt="item.name"
            @click="openUrl(item.url, item.sendSensorsName)"
            @mouseenter="enter(index)"
            @mouseleave="leave"
          >
          <div v-show="isMaxScreen && item.isHover && showHoverIndex === index" class="code">
            <img :src="item.hoverImg" alt="">
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sendSensorsMessage } from '../../utils/sensors'
export default {
  data () {
    return {
      imageList: [
        {
          image: require('../../assets/image/home/xiaodang_huishou.png'),
          image1: require('../../assets/image/home/xiaodang_huishou@3x.png'),
          url: 'https://cqdanghuan.com/static/index.html#/?channelId=0040963',
          name: '小当回收',
          sendSensorsName: 'dhgwxdhsz',
          isHover: true,
          hoverImg: require('../../assets/image/head/xiaodanghuishou.png'),
          text: '关注小当回收公众号'
        },
        {
          image: require('../../assets/image/home/xiaoadng_jingpai.png'),
          image1: require('../../assets/image/home/xiaodang_jingpai@3x.png'),
          url: 'https://www.xiaodangjingpai.com',
          name: '小当竞拍',
          sendSensorsName: 'dhgwxdjpz',
          isHover: false
        },
        {
          image: require('../../assets/image/home/xiaodang_yanxuan.png'),
          image1: require('../../assets/image/home/xiaodang_yanxuan@3x.png'),
          url: 'http://www.xiaodangyanxuan.com',
          name: '小当严选',
          sendSensorsName: 'dhgwxdyxz',
          isHover: true,
          hoverImg: require('../../assets/image/home/erweima_yanxuan.png'),
          text: '下载小当严选 APP'
        }
      ],
      showYanxuanCode: false,
      showHoverIndex: null
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    // 埋点
    sendSensorsMessage(name) {
      sendSensorsMessage(name, {})
    },
    openUrl (url, sendSensorsName) {
      this.showYanxuanCode = false
      this.sendSensorsMessage(sendSensorsName)
      window.open(url)
    },
    enter (index) {
      this.showHoverIndex = index
      // if (index === this.imageList.length - 1) {
      //   this.showYanxuanCode = true
      // }
    },
    leave () {
      this.showHoverIndex = null
      // if (index === this.imageList.length - 1) {
      //   this.showYanxuanCode = false
      // }
    }
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 980px) {
  .home {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .content-item {
      display: flex;
      flex-direction: column;
      .content-items {
        padding-top: 55px;
        box-sizing: border-box;
        p {
          margin: 0;
          padding: 0;
          text-align: left;
          font-size: 32px;
          line-height: 32px;
        }
        .title {
          margin-bottom: 22px;
          font-size: 32px;
          line-height: 32px;
          color: #333;
          font-weight: 550;
        }
        .text {
          display: inline-block;
          color: #999;
          font-size: 24px;
          margin-bottom: 11px;
          text-align: left;
        }
        .image-list {
          // margin-top: 44px;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          img {
            width: 226px;
            height: 176px;
          }
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .home {
    width: 100%;
    .main-content {
      width: 100%;
      .white {
        background: white;
      }
      .gray {
        background: #F6F6F6;
      }
      .content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .content-items {
        width: 1200PX;
        padding: 90PX 0;
        box-sizing: border-box;
        .title {
          font-size: 36PX;
          font-weight: 500;
          color: #111111;
          line-height: 36PX;
          text-align: center;
          margin: 0;
        }
        .text {
          display: inline-block;
          font-size: 22PX;
          margin-top: 20PX;
        }
        .image-list {
          margin-top: 44PX;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          .image-item {
            width: 384PX;
            height: 300PX;
            position: relative;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .code {
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 20PX;
            top: 0;
            right: 0;
            bottom: 0;
            background: #FF9600;
            // opacity: 0.9;
            background: rgba(255, 150, 0, 0.9);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            pointer-events: none;
            img {
              width: 140PX;
              height: 140PX;
              margin-bottom: 20PX;
            }
            span {
              font-size: 24PX;
              color: #FFF;
            }
          }
        }
      }
    }
  }
}
</style>
